<template>
  <div class="main-chapter1">
    <div class="chapter-title">
      Перечень актов освидетельствования скрытых работ и актов промежуточной приемки ответственных конструкций
    </div>
    <n-table :columns="columns" :data="data" :loading="$var('load')">
    </n-table>
  </div>
</template>

<script>
export default {
  name: 'MainChapter3',
  props: [ 'project', 'journal', ],
  data: () => ({
    columns: [
      { name: 'fullName', title: '№ п.п.', },
      { name: 'speciality', title: 'Наименование актов', },
      { name: 'number', title: 'Дата подписания акта', },
    ],
    data: [],
  }),
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.spec32.three.get(this.project.id, 'spec32').then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
